<template>
  <div id="browseview">
    <b-row style="margin: auto">
      <b-col cols="3">    
        <TMLinks />
      </b-col>
    <b-col cols=9>
      <b-tabs content-class="mt-3">
      <b-tab v-if="journ_ready" title="Journal Issues" active>
        <b-row class="m-3">
          <b-col cols="2">
            Journal
            <b-form-select
              v-model="journal_selected"
              :options="journals"
              :select-size="5"
            >
            </b-form-select>
          </b-col>
          <b-col cols="1">
            Year
            <b-form-select
              v-model="year_selected"
              :options="years"
              :select-size="5"
            >
            </b-form-select>
          </b-col>
          <b-col cols="1">
            Volume.Issue
            <b-form-select
              v-model="voliss_selected"
              :options="voliss"
              :select-size="5"
            >
            </b-form-select>
          </b-col>
        </b-row>
        <div v-if="journal_selected && year_selected && voliss_selected">
        <journal-issue 
          :issue_details="journal_issue[journal_selected][year_selected][voliss_selected]"
          :journal_abbr="journal_selected"
          :year="year_selected"
          :voliss="voliss_selected"
        />
        </div>
      </b-tab>
      <b-tab v-if="prop_ready" title="Properties">
        <BrowseProperty
          :property_details="property_details"
          :search_button="search_button"
          :dset_types="dset_types"
        />
      </b-tab>
    </b-tabs>
    </b-col>
    </b-row>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import TMLinks from '@/components/TMLinks.vue';
import BrowseProperty from "@/components/Browse/Property.vue";
import JournalIssue from '../components/Browse/JournalIssue.vue';

export default {
  name: "TmlBrowse",
  components: {
    TMLinks,
    BrowseProperty,
    JournalIssue
  },
  data() {
    return {
      year_selected: null,
      voliss_selected: null,
      property_details: {},
      journal_issue: {},
      search_button: true,
      dset_types: ["pure", "binary", "ternary", "reaction"],
      journal_selected: null,
      journals: [
        "J. Chem. Eng. Data",
        "J. Chem. Thermodyn.",
        "Thermochim. Acta",
        "Fluid Phase Equilib.",
        "Int. J. Thermophys.",
      ],
      prop_ready: false,
      journ_ready: false,
    };
  },
  computed: {
    years() {
      if (this.journal_selected == null) return [];
      return Object.keys(this.journal_issue[this.journal_selected]);
    },
    voliss() {
      if (this.journal_selected == null || this.year_selected == null)
        return [];

      if (
        ! Object.prototype.hasOwnProperty.call(this.journal_issue[this.journal_selected], this.year_selected)
        )
        return [];

      let vis = Object.keys(
        this.journal_issue[this.journal_selected][this.year_selected]
      )
        .map((vi) => vi.split("."))
        .sort((a, b) => {
          //the volumes may be a range!
          let vol_a = a[0].match(/^(\d+)-?/);
          let vol_b = b[0].match(/^(\d+)-?/);

          if (vol_a[1] == vol_b[1]) {
            let iss_a = a[1].match(/^(\d+)-?/);
            let iss_b = b[1].match(/^(\d+)-?/);
            return [iss_a[1] - iss_b[1]];
          } else {
            return vol_a[1] - vol_b[1];
          }
        })
        .map((v_i) => v_i.join("."));
      return vis;
    },
  },
  methods: {
    fetchData() {
      axios.get("./jsons/journal_issue.json").then((response) => {
        this.journal_issue = response.data;
        this.journ_ready = true;
      });
      axios.get("./jsons/data_summary.json").then((response) => {
        this.property_details = response.data;
        this.prop_ready = true;
      });
    },
  },
  created() {
    // Fetch Data
    this.fetchData();
  },
};
</script>

<style lang="scss">
#browseview {
  a {
    color: #11263d;
  }
}
</style>